// extracted by mini-css-extract-plugin
module.exports = {"pageInfo":"PageInfo_pageInfo__1vbL_"};